<template>
<div class="chapter">
<div class="inner_page">
<div class="chapter" id="chapter5">
<h1 class="left"><a id="page_39"></a><a href="#/005toc#ch5"><span class="yellow">HERBED CHICKEN COCKTAIL BITES</span></a></h1>
<p class="noindent">Meatballs are always a favorite party food and are the first to go. Serve these chicken bites with a tasty mustard dipping sauce for extra flavor. These bites can be baked ahead and frozen, if desired, and then reheated.</p>
<p class="hang-space1">1<sup class="frac">1</sup>/<sub class="frac">4</sub> pounds ground chicken</p>
<p class="hang"><sup class="frac">1</sup>/<sub class="frac">4</sub> cup mayonnaise</p>
<p class="hang">3 tablespoons fine dried bread crumbs</p>
<p class="hang">2 tablespoons minced fresh parsley</p>
<p class="hang">1 tablespoon finely chopped yellow onion</p>
<p class="hang"><sup class="frac">1</sup>/<sub class="frac">2</sub> teaspoon celery seed</p>
<p class="hang"><sup class="frac">1</sup>/<sub class="frac">2</sub> teaspoon salt</p>
<p class="hang"><sup class="frac">1</sup>/<sub class="frac">4</sub> teaspoon dried oregano</p>
<p class="hang"><sup class="frac">1</sup>/<sub class="frac">4</sub> teaspoon dried basil</p>
<p class="hang">Freshly ground pepper</p>
<p class="hang">Mustard Sauce (recipe follows) for dipping</p>
<p class="noindent-space1">Preheat the oven to 400°F. In a medium bowl, mix together all the ingredients except the Mustard Sauce, adding pepper to taste. Form into <sup class="frac">3</sup>/<sub class="frac">4</sub>- to 1-inch balls. Arrange the balls on a lightly sprayed or oiled baking sheet in a single layer and bake until lightly browned, 12 to 15 minutes. Transfer to a serving plate or chafing dish and serve hot with Mustard Sauce and toothpicks for spearing.</p>
<p class="noindent-space1">Makes about 3 dozen</p>
<h4><strong>MUSTARD SAUCE</strong></h4>
<p class="hang"><sup class="frac">1</sup>/<sub class="frac">2</sub> cup mayonnaise</p>
<p class="hang"><sup class="frac">1</sup>/<sub class="frac">4</sub> cup plain nonfat yogurt</p>
<p class="hang">3 tablespoons Dijon mustard</p>
<p class="hang">1 tablespoon white wine vinegar</p>
<p class="hang">1 teaspoon ground mustard</p>
<p class="hang">1 teaspoon Worcestershire sauce</p>
<p class="noindent-space1">In a small bowl, whisk together all the ingredients.</p>
<p class="noindent-space1">Makes about 1 cup</p>
</div>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// 013-chapter5.vue?7f1b2058